import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.styl'],
  encapsulation: ViewEncapsulation.None
})
export class LinkComponent {
  @Input() linkText: string;
	@Input() linkUrl: string;
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/components/link/link.component.ts